gsap.registerPlugin(ScrollTrigger, SplitText);



// GSAP: HERO ANIMATION
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// SCROLL SPY
// STICKY NAVIGATION
// GSAP: PROGRESS BAR
// GSAP: TEXT ANIMATIONS
// GSAP: 3FS BANNER STACKING
// GSAP: SUB PAGE IMAGES ANIMATION
// RESPONSIVE VIDEO!



//
// =GSAP: HERO ANIMATION
// --------------------------------------------------

window.addEventListener('load', function () {
  const tlHero = gsap.timeline({
    delay: 0.5
  });

  const navItems = document.querySelectorAll('.msdw-nav .msdw-nav-item');
  const heroImg = document.querySelector('.msdw-section-headvisual img');
  const heroScrollDown = document.querySelector('.msdw-section-headvisual .msdw-scroll-down');

  if (navItems.length) {
    navItems.forEach(navItem => {
      tlHero.from(navItem, {
        autoAlpha: 0,
        x: -50,
        stagger: 0.075
      });
    });
  }

  heroImg && tlHero.from(heroImg, {
    duration: 0.75,
    autoAlpha: 0.7,
  });

  heroScrollDown && tlHero.from(heroScrollDown, {
    duration: 0.85,
    autoAlpha: 0,
    y: -50,
  });
});



//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// document.querySelectorAll('.msdw-page-scroll').forEach(function(link) {
//   link.addEventListener('click', function(e) {
//     if (location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '')
//         && location.hostname === link.hostname) {

//       let target = document.querySelector(link.hash);
//       if (!target) {
//         target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
//       }

//       if (target) {
//         e.preventDefault(); // stop default jump

//         // offset logic
//         // let offsetValue = 0;
//         // if (window.innerWidth > 899) {
//         //   offsetValue = 104;
//         // }

//         // scroll smoothly with offset
//         window.scrollTo({
//           top: target.offsetTop, // - offsetValue,
//           behavior: 'smooth'
//         });
//       }
//     }
//   });
// });



document.querySelectorAll('.msdw-page-scroll').forEach(function(link) {
  link.addEventListener('click', function(e) {
    if (location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '')
        && location.hostname === link.hostname) {

      let target = document.querySelector(link.hash);
      if (!target) {
        target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
      }

      if (target) {
        e.preventDefault();

        gsap.to(window, {
          duration: 1,
          scrollTo: { y: target, autoKill: true },
          ease: "power2.out"
        });
      }
    }
  });
});




//
// =SCROLL SPY
// --------------------------------------------------

const sections = document.querySelectorAll('section[data-scroll-spy]');

if (sections) {
  const cb = (entries) => {
    entries.forEach((entry) => {
      const id = entry.target.getAttribute('id');
      entry.isIntersecting ?
        document.querySelector(`a[data-scroll-spy][href="#${id}"]`).classList.add('msdw-active') :
        document.querySelector(`a[data-scroll-spy][href="#${id}"]`).classList.remove('msdw-active');
    });
  };

  const observer = new IntersectionObserver(cb, {
    // root
    // rootMargin: '-50%'
    // threshold: [0.15, 0.25]
  });

  sections.forEach((el) => observer.observe(el));
}



//
// =STICKY NAVIGATION
// --------------------------------------------------

// document.addEventListener('DOMContentLoaded', function () {
//   const navbar = document.querySelector('.msdw-nav-sticky');

//   if (navbar) {
//     ScrollTrigger.create({
//       trigger: navbar,
//       start: "top top",
//       endTrigger: "body",
//       // end: "bottom +=100px",                 // stay pinned until end of page
//       end: () => ScrollTrigger.maxScroll(window),
//       pin: true,
//       pinSpacing: false, // prevents extra space from being injected
//       toggleClass: {
//         targets: navbar,
//         className: "sticky"
//       }
//     });
//   }
// });



// document.addEventListener("DOMContentLoaded", () => {
//   const navbar = document.querySelector('.msdw-nav-sticky');
//   if (!navbar) return;

//   const mm = gsap.matchMedia();

//   mm.add("(min-width: 1200px)", () => {
//     ScrollTrigger.create({
//       trigger: navbar,
//       start: "top top",
//       end: `+=${window.innerHeight * 4}`, // desktop panels = 400%
//       pin: true,
//       pinSpacing: false,
//       toggleClass: { targets: navbar, className: "sticky" }
//     });
//   });

//   mm.add("(max-width: 1199px)", () => {
//     ScrollTrigger.create({
//       trigger: navbar,
//       start: "top top",
//       end: `+=${window.innerHeight * 6}`, // mobile panels = 600%
//       pin: true,
//       pinSpacing: false,
//       toggleClass: { targets: navbar, className: "sticky" }
//     });
//   });
// });



document.addEventListener("DOMContentLoaded", () => {
  const navbar = document.querySelector(".msdw-nav-sticky");
  if (!navbar) return;

  const navbarTop = navbar.getBoundingClientRect().top + window.scrollY;
  const marginTop = parseFloat(getComputedStyle(navbar).marginTop) || 0;

  window.addEventListener("scroll", () => {
    if (window.scrollY >= navbarTop) {
      if (!navbar.classList.contains("sticky")) {
        navbar.classList.add("sticky");

        // lock it in visually where it was
        navbar.style.position = "fixed";
        navbar.style.top = `${-marginTop}px`; // preserve negative margin effect
        navbar.style.left = "0";
        navbar.style.right = "0";
        navbar.style.zIndex = "9999";
      }
    } else {
      if (navbar.classList.contains("sticky")) {
        navbar.classList.remove("sticky");
        navbar.style.position = "";
        navbar.style.top = "";
        navbar.style.left = "";
        navbar.style.right = "";
        navbar.style.zIndex = "";
      }
    }
  });
});



//
// =GSAP: PROGRESS BAR
// --------------------------------------------------

// document.addEventListener('DOMContentLoaded', () => {
//   const progressBar = document.querySelector(".msdw-progress-bar");

//   if (progressBar) {
//     // PROGRESS BAR
//     ScrollTrigger.create({
//       trigger: "body",
//       start: "top top",
//       end: "bottom bottom",
//       onUpdate: self => {
//         const progress = self.progress * 100;

//         progressBar.style.background =
//           `linear-gradient(90deg, #000 ${progress}%, rgba(0,0,0,0) ${progress}%)`;
//       }
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', () => {
  const progressBar = document.querySelector(".msdw-progress-bar");

  if (progressBar) {
    // update function based on GSAP's maxScroll
    function updateProgress() {
      const progress = window.scrollY / ScrollTrigger.maxScroll(window);
      progressBar.style.background =
        `linear-gradient(90deg, #000 ${progress * 100}%, rgba(0,0,0,0) ${progress * 100}%)`;
    }

    // attach to scroll + refresh
    window.addEventListener("scroll", updateProgress);
    ScrollTrigger.addEventListener("refresh", updateProgress);

    // initialize
    updateProgress();
  }
});



//
// =GSAP: TEXT ANIMATIONS
// --------------------------------------------------

const section = document.querySelector('.msdw-section-different');

function setupSplits1() {
  const animChars = gsap.utils.toArray(".msdw-text-anim-chars");
  animChars.forEach((animChar) => {
    new SplitText(animChar, {
      type: "chars, words, lines",
      mask: "words",
      charsClass: "char",
      wordsClass: "word",
      onSplit: (self) => {
        gsap.set(animChar, {autoAlpha: 1});
        gsap.from(self.chars, {
          y: 100,
          autoAlpha: 0,
          stagger: 0.02,
          scrollTrigger: {
            trigger: animChar,
            start: "top bottom",
            end: "bottom center"
          }
        });

        // ✅ Refresh ScrollTriggers after SplitText wraps text
        ScrollTrigger.refresh();
      }
    });
  });
}

function setupSplits2() {
  const animLines = gsap.utils.toArray(".msdw-text-anim-lines");
  animLines.forEach((animLine) => {
    new SplitText(animLine, {
      type: "lines",
      mask: "lines",
      autoSplit: true,
      onSplit: (self) => {
        gsap.set(animLine, {autoAlpha: 1});
        gsap.from(self.lines, {
          y: 100,
          autoAlpha: 0,
          stagger: 0.15,
          scrollTrigger: {
            trigger: animLine,
            start: "top 95%",
            end: "bottom center"
          }
        });

        // ✅ Refresh ScrollTriggers after SplitText wraps text
        ScrollTrigger.refresh();
      }
    });
  });
}

// --------------------------------
// Wait for fonts to load, then init
// --------------------------------
document.fonts.ready.then(() => {
  setupSplits1();
  setupSplits2();

  // --------------------------------
  // Now initialize panels-wrapper
  // --------------------------------
  if (section) {
    initPanels();           // Your panels-wrapper ScrollTriggers
    ScrollTrigger.refresh(); // Recalculate everything now that layout is stable
    requestAnimationFrame(() => ScrollTrigger.refresh());
  }
});



//
// =GSAP: 3FS BANNER STACKING
// --------------------------------------------------

if (section) {
  const h2s = gsap.utils.toArray('.msdw-panel-hl');

  let currentIndex = -1;
  let isScrollingToPanel = false;

  const mm = gsap.matchMedia();

  // ---------------- MOBILE ----------------
  mm.add("(max-width:1199px)", () => {
    // initialize with msdw-active-1
    section.classList.remove("msdw-ghost","msdw-active-1","msdw-active-2","msdw-active-3","msdw-active-4","msdw-active-5","msdw-active-6");
    section.classList.add("msdw-active-1");

    window.addEventListener('load', function () {
      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "+=600%",
        pin: true,
        // markers: true,
        onUpdate: self => {
          if(isScrollingToPanel) return;
          const progress = self.progress;
          let index;
          if(progress < 1/6) index = 0;
          else if(progress < 2/6) index = 1;
          else if(progress < 3/6) index = 2;
          else if(progress < 4/6) index = 3;
          else if(progress < 5/6) index = 4;
          else index = 5;

          section.classList.remove("msdw-active-1","msdw-active-2","msdw-active-3","msdw-active-4","msdw-active-5","msdw-active-6");
          section.classList.add("msdw-active-" + (index+1));
        }
      });
    });
  });

  // ---------------- DESKTOP ----------------
  mm.add("(min-width:1200px)", () => {
    // initialize with msdw-ghost
    section.classList.remove("msdw-ghost","msdw-active-1","msdw-active-2","msdw-active-3","msdw-active-4","msdw-active-5","msdw-active-6");
    section.classList.add("msdw-ghost");

    window.addEventListener('load', function () {
      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "+=400%",
        pin: true,
        // markers: true,
        onUpdate: self => {
          if(isScrollingToPanel) return;

          const progress = self.progress;
          let index;
          if(progress < 0.25) index = -1;   // msdw-ghost
          else if(progress < 0.5) index = 0;
          else if(progress < 0.75) index = 1;
          else index = 2;

          section.classList.remove("msdw-active-1","msdw-active-2","msdw-active-3","msdw-ghost");
          if(index < 0) section.classList.add("msdw-ghost");
          else section.classList.add("msdw-active-" + (index+1));

          // h2 pointer-events only while pinned
          h2s.forEach(h2 => h2.style.pointerEvents = self.isActive ? "auto" : "none");

          currentIndex = index;
        }
      });

      // ScrollTo for left h2 anchors
      if (typeof ScrollToPlugin !== "undefined") {
        gsap.registerPlugin(ScrollToPlugin);

        h2s.forEach((h2, idx) => {
          h2.style.cursor = "pointer";
          h2.addEventListener("click", () => {
            if(isScrollingToPanel) return;
            isScrollingToPanel = true;

            const scrollTarget = section.offsetTop + window.innerHeight * (idx + 2);

            section.classList.remove("msdw-active-1","msdw-active-2","msdw-active-3","msdw-ghost");
            section.classList.add("msdw-active-" + (idx + 1));
            currentIndex = idx;

            gsap.to(window, {
              duration: 1.2,
              scrollTo: {y: scrollTarget, autoKill: true},
              ease: "power2.out",
              onComplete: () => {
                isScrollingToPanel = false;
              }
            });
          });
        });
      }
    });
  });
}



// const cards = gsap.utils.toArray('.msdw-swipe');

// // "load" -> better results for pinning on Production
// window.addEventListener('load', function () {
//   cards.forEach((card, i) => {
//     gsap.to(card, {
//       ease: "none",
//       scrollTrigger: {
//         trigger: card,
//         start: "top top",
//         end: "bottom bottom",
//         endTrigger: ".msdw-section-different",
//         scrub: true,
//         pin: card,
//         pinSpacing: false,
//         // invalidateOnRefresh: true,
//       }
//     });
//   });
// });



// let panels = gsap.utils.toArray(".msdw-panel"),
//     currentPanel = panels[0];

// gsap.defaults({overwrite: 'auto', duration: 1});

// // create a ScrollTrigger for each panel
// panels.forEach((panel, i) => {
//   ScrollTrigger.create({
//     trigger: '.msdw-panel-wrapper',
//     pin: true,
//     start: (self) => i === 0 ? "top top" : self.previous().end,
//     end: () => "+=" + innerHeight,
//     scrub: true,
//     markers: true,
//     toggleClass: {targets: panel, className: "active"},
//     toggleActions: "play reset play reset",
//     // when a new panel activates (from either direction), set the panel accordingly.
//     onToggle: self => self.isActive && setPanel(panel)
//   });
// });

// function setPanel(newPanel) {
//   if (newPanel !== currentPanel) {
//     gsap.timeline()
//       .to(currentPanel.querySelector(".msdw-dark-opacity-bg"), { x: "100%", duration: 0.33 })
//       .to(currentPanel.querySelector("img"), { autoAlpha: 0, duration: 0.33 })
//       .to(currentPanel, { autoAlpha: 0, duration: 0.33 })

//     gsap.timeline()
//       .to(newPanel, { autoAlpha: 1, duration: 0.33 })
//       .fromTo(newPanel.querySelector("img"), { autoAlpha: 0 }, { autoAlpha: 1, duration: .33 })
//       .fromTo(newPanel.querySelector(".msdw-dark-opacity-bg"), { x: "100%" }, { x: 0, duration: .33 })

//     currentPanel = newPanel;
//   }
// }


//
// =GSAP: SUB PAGE IMAGES ANIMATION
// --------------------------------------------------

const reveal_duration = 1.5;
const easing_type = "expo.inOut";

document.addEventListener('DOMContentLoaded', () => {
  const imgWrappers = gsap.utils.toArray('.msdw-img-anim-wrapper');

  if (imgWrappers.length) {
    imgWrappers.forEach(function(wrapper) {
      gsap.set(wrapper, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)' });

      ScrollTrigger.create({
        trigger: wrapper,
        start: "top bottom", // when the top of the trigger hits the bottom of the viewport
        // markers: true,
        onEnter: () => { revealItem(wrapper) },
        onLeaveBack: self => self.disable()
      });
    });
  }
});

function revealItem(elem, direction) {
  gsap.to(elem, {
    duration: reveal_duration,
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    ease: easing_type
  });

  gsap.from(elem.querySelector("img"), {
    duration: reveal_duration * 1.2,
    autoAlpha: 0,
    scrub: 1,
    ease: easing_type,
    scale: 1.2,
    delay: 0.0,
  })
}



//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  // Shared breakpoints
  const breakpoints = {
    sm: window.matchMedia('(min-width: 0px) and (max-width: 543px)'),
    md: window.matchMedia('(min-width: 544px) and (max-width: 991px)'),
    lg: window.matchMedia('(min-width: 992px) and (max-width: 1199px)'),
    xl: window.matchMedia('(min-width: 1200px) and (max-width: 99999px)')
  };

  // Get all responsive videos
  const videos = document.querySelectorAll('.msdw-video-responsive');
  const videoWrapper = document.getElementById('videoWrapper');
  const playPauseBtn = document.getElementById('playPauseBtn');
  const replayBtn = document.getElementById('replayBtn');

  // Shared source key function
  function getSourceKey() {
    if (breakpoints.xl.matches) return 'xl';
    if (breakpoints.lg.matches) return 'lg';
    if (breakpoints.md.matches) return 'md';
    return 'sm';
  }

  // Helper function to update media sources for a single video
  function updateVideoSources(video, sourceKey) {
    // Update video source if needed
    const newVideoSource = video.getAttribute(`data-video-${sourceKey}`);
    if (newVideoSource && newVideoSource !== video.src) {
      video.src = newVideoSource;
    }

    // Update poster if needed
    const newPosterSource = video.getAttribute(`data-poster-${sourceKey}`);
    if (newPosterSource && newPosterSource !== video.poster) {
      video.poster = newPosterSource;
    }
  }

  // Initialize each video
  videos.forEach(video => {
    if (video) {
      const playIcon = playPauseBtn.querySelector('.msdw-play-icon');
      const pauseIcon = playPauseBtn.querySelector('.msdw-pause-icon');

      let hasInitialLoad = false;

      // Handle initial load
      function handleInitialLoad() {
        if (!hasInitialLoad) {
          hasInitialLoad = true;
          video.classList.add('msdw-video-loaded');
          // Clean up event listeners
          video.removeEventListener('loadeddata', handleInitialLoad);
          video.removeEventListener('error', handleInitialLoad);
        }
      }

      // Set up initial event listeners
      video.addEventListener('loadeddata', handleInitialLoad);
      video.addEventListener('error', handleInitialLoad);

      // Track if video has been played automatically
      let hasAutoPlayed = false;

      // Play/Pause button functionality
      playPauseBtn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        } else {
          video.pause();
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        }
      });

      // Video event listeners
      video.addEventListener('play', function() {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
        videoWrapper.classList.remove('msdw-video-ended');
      });

      video.addEventListener('pause', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      });

      video.addEventListener('ended', function() {
        videoWrapper.classList.add('msdw-video-ended');
        video.style.opacity = "0";
      });

      // Replay button functionality
      replayBtn.addEventListener('click', function() {
        video.currentTime = 0;
        video.play();
        video.style.opacity = "1";
        videoWrapper.classList.remove('msdw-video-ended');
      });

      // Create Intersection Observer to play video when it enters viewport
      const observerVidAutoPlay = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasAutoPlayed) {
            // Play the video
            video.play().then(() => {
              hasAutoPlayed = true;
              playIcon.style.display = 'none';
              pauseIcon.style.display = 'block';

              // Stop observing after first playback
              observerVidAutoPlay.disconnect();
            }).catch(error => {
              console.error('Error attempting to play video:', error);
            });
          }
        });
      }, {
        threshold: 0.5 // Play when 50% of video is visible
      });

      // Start observing the video
      observerVidAutoPlay.observe(video);

      // Initial source update
      updateVideoSources(video, getSourceKey());
    }
  });

  // Batch update all videos
  function updateAllVideos() {
    const sourceKey = getSourceKey();
    videos.forEach(video => updateVideoSources(video, sourceKey));
  }

  // Debounced resize handler
  let resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllVideos, 100);
  }

  // Set up shared event listeners
  window.addEventListener('resize', handleResize);
  Object.values(breakpoints).forEach(mediaQuery => {
    mediaQuery.addEventListener('change', handleResize);
  });
});
